import React from 'react';
import { product as productLabels } from '../../mockdata';
import { ProductType } from '../../util/types';
import Manual from '../Manual/Manual';
import IndexWrapper from '../IndexWrapper/IndexWrapper';
import Text from '../Text/Text';

interface ProductPageProps extends ProductType {
  locale: string;
  labels: typeof productLabels;
  backLink?: { href: string; children: string };
  localeCountry?: string;
}

export default function ProductPage({
  locale,
  id,
  name,
  localeCountry,
  hasManuals,
  hasMobileManuals,
  hasCartManuals,
  hide_language_selector,
  hide_back_link,
  latest_manual,
  mobile_manual,
  cart_manual,
  labels,
  backLink,
  addendums,
}: ProductPageProps) {
  return (
    <IndexWrapper
      labels={labels}
      hide_back_link={hide_back_link}
      hide_language_selector={hide_language_selector}
      backLink={backLink}
      name={name}
      locale={locale}
      localeCountry={localeCountry}
    >
      {!cart_manual && !mobile_manual && !latest_manual && (
        <Text style={{ fontSize: 18, fontWeight: 'bold' }}>{labels.error_manuals}</Text>
      )}
      {mobile_manual && (
        <Manual
          key={1}
          manual={mobile_manual}
          title={productLabels.user_manual}
          titleAppendix={productLabels.mobile_configuration}
          previousUrl={`${id}/mobile?${
            localeCountry ? `locale_country=${localeCountry}` : `locale=${locale}`
          }`}
          previousLabel={productLabels.previous_versions}
          withPrevious={hasMobileManuals}
        />
      )}
      {cart_manual && (
        <Manual
          key={0}
          manual={cart_manual}
          title={productLabels.user_manual}
          titleAppendix={productLabels.cart_configuration}
          previousUrl={`${id}/cart?${
            localeCountry ? `locale_country=${localeCountry}` : `locale=${locale}`
          }`}
          previousLabel={productLabels.previous_versions}
          withPrevious={hasCartManuals}
        />
      )}
      {latest_manual && (
        <Manual
          key={1}
          manual={latest_manual}
          title={productLabels.user_manual}
          previousUrl={`${id}/manuals?${
            localeCountry ? `locale_country=${localeCountry}` : `locale=${locale}`
          }`}
          previousLabel={productLabels.previous_versions}
          withPrevious={hasManuals}
        />
      )}

      {Array.isArray(addendums) && addendums.length > 0 && (
        <Manual title={productLabels.addendums} manuals={addendums} />
      )}
    </IndexWrapper>
  );
}
